import { hasGrantedAllScopesGoogle, useGoogleLogin } from '@react-oauth/google';

export default (
    onSuccess: (accessToken: string) => void,
    onError: (error: any) => void,
    onNonOAuthError: (error: any) => void
) => {
    return (scopes: string) => {
        return useGoogleLogin({
            onSuccess: async (tokenResponse) => {
                try {
                    const allScopes = scopes.split(' ');
                    if (!hasGrantedAllScopesGoogle.apply(null, [tokenResponse, ...allScopes])) {
                        throw new Error('scope_not_granted');
                    }
                    onSuccess(tokenResponse.access_token);
                } catch (error) {
                    onError(error);
                }
            },
            onError: (error) => onError(error),
            onNonOAuthError: (error) => onNonOAuthError(error),
            scope: scopes
        });
    };
};
